import React from 'react';
import { Link } from 'react-router-dom';

function GuideSuccessPage({ darkMode }) {
  const containerClass = darkMode 
    ? 'min-h-screen bg-gray-900 text-white' 
    : 'min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100';

  const cardClass = darkMode
    ? 'bg-gray-800 border-gray-700 hover:bg-gray-750'
    : 'bg-white border-gray-200 hover:bg-blue-50';

  return (
    <div className={containerClass}>
      <div className="container mx-auto px-4 py-8">
        {/* 헤더 */}
        <div className="text-center mb-12">
          <div className="text-6xl mb-4">📚</div>
          <h1 className="text-4xl font-bold mb-4 bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
            면접 성공 가이드
          </h1>
          <p className={`text-lg ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
            합격률을 높이는 실전 면접 전략 12가지
          </p>
        </div>

        {/* 가이드 카드들 */}
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          
          {/* 1. 자기소개 40초 가이드 */}
          <Link 
            to="/guide-success/self-intro"
            className={`${cardClass} rounded-xl p-6 border transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl`}
          >
            <div className="text-4xl mb-4">🎯</div>
            <h3 className="text-xl font-bold mb-3">자기소개 40초 완벽 가이드</h3>
            <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'} mb-4`}>
              첫인상을 결정하는 40초 자기소개 황금 공식
            </p>
            <div className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full inline-block">
              1번째 가이드
            </div>
          </Link>

          {/* 2. 지원동기 */}
          <Link 
            to="/guide-success/motivation"
            className={`${cardClass} rounded-xl p-6 border transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl`}
          >
            <div className="text-4xl mb-4">🔥</div>
            <h3 className="text-xl font-bold mb-3">지원동기 완벽 공략법</h3>
            <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'} mb-4`}>
              면접관이 원하는 지원동기와 입사 후 포부 만들기
            </p>
            <div className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full inline-block">
              2번째 가이드
            </div>
          </Link>

          {/* 3. 장단점 */}
          <Link 
            to="/guide-success/strengths-weaknesses"
            className={`${cardClass} rounded-xl p-6 border transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl`}
          >
            <div className="text-4xl mb-4">⚖️</div>
            <h3 className="text-xl font-bold mb-3">장단점 솔직하게 어필하기</h3>
            <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'} mb-4`}>
              장점은 겸손하게, 단점은 성장 의지로 전환하기
            </p>
            <div className="text-xs bg-purple-100 text-purple-800 px-2 py-1 rounded-full inline-block">
              3번째 가이드
            </div>
          </Link>

          {/* 4. 면접 말하기 기술 */}
          <Link 
            to="/guide-success/speaking-skills"
            className={`${cardClass} rounded-xl p-6 border transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl`}
          >
            <div className="text-4xl mb-4">🗣️</div>
            <h3 className="text-xl font-bold mb-3">면접 말하기 기술</h3>
            <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'} mb-4`}>
              목소리, 속도, 제스처까지 완벽한 말하기 스킬
            </p>
            <div className="text-xs bg-yellow-100 text-yellow-800 px-2 py-1 rounded-full inline-block">
              4번째 가이드
            </div>
          </Link>

          {/* 5. 면접 복장 가이드 */}
          <Link 
            to="/guide-success/dress-appearance"
            className={`${cardClass} rounded-xl p-6 border transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl`}
          >
            <div className="text-4xl mb-4">👔</div>
            <h3 className="text-xl font-bold mb-3">면접 복장 & 외모 가이드</h3>
            <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'} mb-4`}>
              업종별 완벽한 면접 룩과 첫인상 관리법
            </p>
            <div className="text-xs bg-red-100 text-red-800 px-2 py-1 rounded-full inline-block">
              5번째 가이드
            </div>
          </Link>

          {/* 6. STAR 기법 */}
          <Link 
            to="/guide-success/star-method"
            className={`${cardClass} rounded-xl p-6 border transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl`}
          >
            <div className="text-4xl mb-4">⭐</div>
            <h3 className="text-xl font-bold mb-3">STAR 기법으로 경험 어필</h3>
            <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'} mb-4`}>
              구체적이고 논리적인 경험 스토리텔링 방법
            </p>
            <div className="text-xs bg-indigo-100 text-indigo-800 px-2 py-1 rounded-full inline-block">
              6번째 가이드
            </div>
          </Link>

          {/* 7. 돌발질문 대처법 */}
          <Link 
            to="/guide-success/unexpected-questions"
            className={`${cardClass} rounded-xl p-6 border transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl`}
          >
            <div className="text-4xl mb-4">❓</div>
            <h3 className="text-xl font-bold mb-3">돌발질문 완벽 대처법</h3>
            <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'} mb-4`}>
              예상 못한 질문에도 당황하지 않는 대답 기술
            </p>
            <div className="text-xs bg-orange-100 text-orange-800 px-2 py-1 rounded-full inline-block">
              7번째 가이드
            </div>
          </Link>

          {/* 8. 두괄식 답변법 */}
          <Link 
            to="/guide-success/conclusion-first"
            className={`${cardClass} rounded-xl p-6 border transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl`}
          >
            <div className="text-4xl mb-4">🎯</div>
            <h3 className="text-xl font-bold mb-3">두괄식 답변의 힘</h3>
            <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'} mb-4`}>
              결론부터 말해서 강력한 인상 남기기
            </p>
            <div className="text-xs bg-teal-100 text-teal-800 px-2 py-1 rounded-full inline-block">
              8번째 가이드
            </div>
          </Link>

          {/* 9. 면접 당일 체크리스트 */}
          <Link 
            to="/guide-success/interview-day"
            className={`${cardClass} rounded-xl p-6 border transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl`}
          >
            <div className="text-4xl mb-4">⏰</div>
            <h3 className="text-xl font-bold mb-3">면접 당일 완벽 준비 체크리스트</h3>
            <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'} mb-4`}>
              면접 당일 실수 없이 완벽하게 준비하는 법
            </p>
            <div className="text-xs bg-pink-100 text-pink-800 px-2 py-1 rounded-full inline-block">
              9번째 가이드
            </div>
          </Link>

          {/* 10. 마지막 한마디 */}
          <Link 
            to="/guide-success/final-words"
            className={`${cardClass} rounded-xl p-6 border transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl`}
          >
            <div className="text-4xl mb-4">🎤</div>
            <h3 className="text-xl font-bold mb-3">마지막 한마디로 임팩트 남기기</h3>
            <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'} mb-4`}>
              "마지막으로 하고 싶은 말씀" 완벽 대응법
            </p>
            <div className="text-xs bg-violet-100 text-violet-800 px-2 py-1 rounded-full inline-block">
              10번째 가이드
            </div>
          </Link>

          {/* 11. 멘탈관리법 */}
          <Link 
            to="/guide-success/mental-management"
            className={`${cardClass} rounded-xl p-6 border transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl`}
          >
            <div className="text-4xl mb-4">💪</div>
            <h3 className="text-xl font-bold mb-3">취업 준비 멘탈관리법</h3>
            <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'} mb-4`}>
              탈락과 스트레스를 극복하는 현실적 조언
            </p>
            <div className="text-xs bg-emerald-100 text-emerald-800 px-2 py-1 rounded-full inline-block">
              11번째 가이드
            </div>
          </Link>

          {/* 12. 면접수당 받기 */}
          <Link 
            to="/guide-success/interview-allowance"
            className={`${cardClass} rounded-xl p-6 border transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl`}
          >
            <div className="text-4xl mb-4">💰</div>
            <h3 className="text-xl font-bold mb-3">면접수당 받는 방법</h3>
            <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'} mb-4`}>
              지자체 지원 프로그램과 기업 면접수당 현실적 정보
            </p>
            <div className="text-xs bg-cyan-100 text-cyan-800 px-2 py-1 rounded-full inline-block">
              12번째 가이드
            </div>
          </Link>

        </div>

        {/* 하단 CTA - 버튼 2개 추가 */}
        <div className="text-center mt-12 space-y-4 md:space-y-0 md:space-x-6 md:flex md:justify-center">
          <Link 
            to="/" 
            className={`inline-flex items-center px-8 py-3 rounded-xl font-semibold transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl ${
              darkMode 
                ? 'bg-blue-600 hover:bg-blue-700 text-white' 
                : 'bg-blue-500 hover:bg-blue-600 text-white'
            }`}
          >
            🎯 면접 연습 시작하기
          </Link>
          
          <a 
            href="https://jobangel.tistory.com/" 
            target="_blank" 
            rel="noopener noreferrer"
            className={`inline-flex items-center px-8 py-3 rounded-xl font-semibold transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl ${
              darkMode 
                ? 'bg-green-600 hover:bg-green-700 text-white' 
                : 'bg-green-500 hover:bg-green-600 text-white'
            }`}
          >
            📝 더 많은 취업정보 보러가기 [취업천사블로그]
          </a>
        </div>
      </div>
    </div>
  );
}

export default GuideSuccessPage;